import { render, staticRenderFns } from "./DiaryIcon.vue?vue&type=template&id=d89502f8&"
import script from "./DiaryIcon.vue?vue&type=script&lang=js&"
export * from "./DiaryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports